import React, { useState } from 'react';
import { Container, Form, Row, Col, Navbar, Button } from 'react-bootstrap';
import Slider from 'react-rangeslider';

const nextDefault = () => { };

const RangeSelector = ({ next = nextDefault }) => {
  const base = 10;
  const [ranges, setRanges] = useState([
    {
      key: 'quality',
      text: 'Qualidade',
      value: 0,
    },
    {
      key: 'time',
      text: 'Tempo',
      value: 10,
    },
    {
      key: 'value',
      text: 'Preço',
      value: 0,
    },
  ]);

  const handleChange = (value, range) => {
    const deltaValue = value - range.value;

    let newRange = ranges;

    if (range.key === 'quality') {
      newRange = ranges.map((obj) => {
        if (obj.key === range.key) {
          return {
            ...obj,
            value,
          };
        } if (obj.key === 'value') {
          return {
            ...obj,
            value: obj.value + (deltaValue / 2),
          };
        }

        return {
          ...obj,
          value: obj.value,
        };
      });
    }
    if (range.key === 'time') {
      newRange = ranges.map((obj) => {
        if (obj.key === range.key) {
          return {
            ...obj,
            value,
          };
        } if (obj.key === 'value') {
          return {
            ...obj,
            value: (obj.value + (-(deltaValue / 2))),
          };
        }

        return {
          ...obj,
          value: obj.value,
        };
      });
    }
    if (range.key === 'value') {
      newRange = ranges.map((obj) => {
        if (obj.key === range.key) {
          return {
            ...obj,
            value,
          };
        }
        if (obj.key === 'quality') {
          return {
            ...obj,
            value: obj.value + (deltaValue),
          };
        }
        if (obj.key === 'time') {
          return {
            ...obj,
            value: obj.value + (-(deltaValue)),
          };
        }

        return {
          ...obj,
          value: obj.value,
        };
      });
    }

    setRanges(newRange);
  };

  const continueAction = () => {
    next(ranges);
  };

  return (
    <Container>
      <Row className="my-5 justify-content-md-center">
        <Col md="5">
          <Form>
            {
              ranges.map((range) => (
                <Form.Group controlId="formBasicRange">
                  <h5 className="bold c-dark">{range.text}</h5>
                  <Slider
                    min={0}
                    max={base}
                    value={range.value}
                    onChange={(value) => handleChange(value, range)}
                  />
                </Form.Group>
              ))
            }
          </Form>
        </Col>

      </Row>
      <div className="fixed-bottom mb-xl-4">
        <Navbar expand="lg" variant="transparent">
          <Container fluid="lg" className="py-4 px-md-7 px-md-4 robot-box">
            <Col xs={12} className="d-flex justify-content-center align-items-center my-5">
              <Button size="md" className="px-5 py-3 btn-min-lg" variant="purple" onClick={continueAction}>
                Continuar
              </Button>
            </Col>
          </Container>
        </Navbar>
      </div>
    </Container>
  );
};

export default RangeSelector;
